import styled, { css } from 'styled-components';
import { FuelToast } from '@frete.com/fuel-react';
import { WIDTH_MENU_HOST } from '@constants';
import { mediasQuery } from '@utils/responsive';
import { ToastPropsInterface } from './ToastTypes';

interface CustomFuelToastInterface {
  slug: ToastPropsInterface['slug'];
}

export const CustomFuelToast = styled(FuelToast)<CustomFuelToastInterface>`
  position: fixed;
  text-transform: none;
  z-index: 2102;
  max-width: 470px;

  ${({ theme, slug }) =>
    /*
    caso seja `proposal_register` significa que está dentro do drawer, por isso,
    temos um posicionamento diferente do default do DS
   */
    slug === 'proposal_register'
      ? css`
          bottom: 120px;
          left: ${theme.spacing.km6};
        `
      : css`
          left: calc(${WIDTH_MENU_HOST} + ${theme.spacing.km8});
          bottom: ${theme.spacing.km10};

          ${mediasQuery.maxMdMax} {
            left: ${theme.spacing.km6};
            bottom: ${theme.spacing.km8};
            max-width: calc(100vw - ${theme.spacing.km12});
          }
        `}
`;
